import { ref, watchEffect } from "vue";

export const useSkeleton = () => {
  const isSkeletonVisible = ref(false);

  const setSkeletonOn = () => {
    isSkeletonVisible.value = true;
  };

  const setSkeletonOff = () => {
    setTimeout(() => {
      isSkeletonVisible.value = false;
    }, 300);
  };

  return { isSkeletonVisible, setSkeletonOn, setSkeletonOff };
};
  